export default __webpack_public_path__ + "assets/ico_arrow_scroll_down-0bb45fd6.svg";